import { Classes } from "@blueprintjs/core";
import { createGlobalStyle } from "styled-components";

import { popoverStyles } from "../hex-components/HexPopover";

import { ThemeResetVariables } from "./common/reset";
import { Theme } from "./common/theme";
import { toastStyles } from "./common/toasts";

export const CssVariableInjector = createGlobalStyle<{
  theme: Theme;
}>`
  body {
    ${({ theme }) => theme.globalCSSVars}
  }
`;

export const CustomStylesOverrides = createGlobalStyle<{
  theme: Theme;
  className: string;
  $scrollContent?: boolean;
}>`
  #vg-tooltip-element.custom-theme {
    font-family: ${({ theme }) => theme.fontFamily.DEFAULT};
    background-color: ${({ theme }) => theme.backgroundColor.DEFAULT};
    color: ${({ theme }) => theme.fontColor.DEFAULT};

    td.key {
      color: ${({ theme }) => theme.fontColor.MUTED};
    }
  }

  .${({ className }) => className} .${Classes.POPOVER} {
    ${ThemeResetVariables}
    ${popoverStyles}
  }

  .${({ className }) => className} {
    ${toastStyles}

    .${Classes.TOAST} {
      font-family: ${({ theme }) => theme.fontFamily.DEFAULT};
    }
  }
`;
